export const MATCH_TYPES = {
  ALL: 'all',
  ANY: 'any',
} as const;
